<template>
  <div v-if="isDouble && isValues" class="value-wrapper">
    <VInput
      type="number"
      disableActiveAndFocus
      class="range-input"
      :value="filters[type][0].toString()"
      @update:value="updateValue([+$event, filters[type][1]])"
    />
    <VInput
      type="number"
      disableActiveAndFocus
      class="range-input"
      :value="filters[type][1]"
      @update:value="updateValue([filters[type][0], +$event])"
    />
  </div>
  <vue-slider
    v-if="isDouble"
    v-model="value"
    :min="valueMin"
    :max="valueMax"
    :step="interval"
    :format="isValues ? null : format"
    @update="emitChange"
    :tooltipPosition="yPos"
    :tooltips="tooltips && !isValues"
    :default="defaultValues"
    :merge="merge"
    :lazy="lazy"
  />
  <vue-slider
    v-else
    v-model="value"
    :min="valueMin"
    :max="valueMax"
    :step="interval"
    :format="format"
    :tooltipPosition="yPos"
    :tooltips="tooltips"
    @update="emitChange"
    :lazy="lazy"
  />
</template>

<script>
import VueSlider from "@vueform/slider";
import VInput from "@/components/ui/VInput.vue";
export default {
  name: "VRange",
  components: { VInput, VueSlider },
  props: {
    valueMax: [Number],
    valueMin: { type: Number, default: 0 },
    valueRange: [Number],
    yPos: {
      type: String,
      default: "top",
    },
    type: {
      type: String,
      default: "top",
    },
    tooltips: {
      type: Boolean,
      default: true,
    },
    isDouble: {
      type: Boolean,
      default: false,
    },
    isValues: {
      type: Boolean,
      default: false,
    },
    defaultValues: {
      type: Array,
    },
    filters: {
      type: Array,
    },
    merge: {
      type: Number,
      default: -1,
    },
    interval: { type: Number, default: 1 },
    formatMarker: {
      type: String,
      default: "",
    },
    lazy: {
      type: Boolean,
      default: true,
    },
  },

  data() {
    return {
      value: this.valueRange,
      format: (value) => {
        return `${Math.round(value)}  ${this.formatMarker}`;
      },
    };
  },

  watch: {
    valueRange(newValue) {
      this.value = newValue;
    },
  },

  methods: {
    emitChange() {
      this.$emit("on-change", this.value);
    },
    updateValue(newValue) {
      this.value = newValue;
      this.emitChange();
    },
  },
};
</script>
<style>
.slider-touch-area {
  border-radius: 50%;
  border: 2px solid #f18e35;
}
</style>

<style scoped lang="scss">
.value-wrapper {
  display: flex;
  height: 40px;
  width: 100%;
  margin-bottom: 28px;

  div {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    width: 50%;
    height: 100%;
    padding: 10px 12px;

    font-weight: 400;
    font-size: 12px;
    line-height: 22px;
  }
}

.range-input {
  font-size: 12px;

  &:first-child {
    border-radius: 8px 0 0 8px;
  }

  &:nth-child(2) {
    border-radius: 0 8px 8px 0;
  }
}
</style>

<style src="@vueform/slider/themes/default.css"></style>
